import React from 'react';
import '../../assets/styles/SuperAdmin/SATheme.css';
import '../../assets/styles/SuperAdmin/SASecurity.css';

const SASecurity = ({ settings, onToggle }) => {
    const policies = [
        { key: "sa_auth_pin", label: "Global PIN Protection", desc: "Require a 6-digit PIN for all Super Admin actions", icon: "🛡️" },
        { key: "two_factor", label: "Two-Factor Auth", desc: "Enforce 2FA for all administrative roles across all portals", icon: "📱" },
        { key: "audit_logs", label: "Immutable Logging", desc: "Prevent deletion of audit logs for 90 days", icon: "📜" },
        { key: "session_timeout", label: "Aggressive Timeout", desc: "Auto-logout inactive admin sessions after 5 minutes", icon: "⏲️" },
        { key: "ip_whitelist", label: "IP Restriction", desc: "Only allow access from corporate VPN and designated office IPs", icon: "🌐" },
        { key: "data_encrypt", label: "Payload Encryption", desc: "Encrypt all administrative communication between client and server", icon: "🔐" },
    ];

    return (
        <div className="animate-in">
            <div style={{ marginBottom: 24 }}>
                <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, fontFamily: "'Sora'" }}>Security Policies</h2>
                <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--sa-muted)" }}>Configure global protocol settings and system-wide security defaults</p>
            </div>

            <div className="sa-security-grid">
                {policies.map(p => (
                    <div key={p.key} className="sa-policy-card">
                        <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                            <div style={{ fontSize: 28 }}>{p.icon}</div>
                            <div style={{ flex: 1 }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                                    <span style={{ fontSize: 15, fontWeight: 700 }}>{p.label}</span>
                                    <div className={`sa-toggle ${settings[p.key] ? 'on' : ''}`} onClick={() => onToggle(p.key)}>
                                        <div className="sa-toggle-knob" />
                                    </div>
                                </div>
                                <div style={{ fontSize: 12, color: "var(--sa-muted)", lineHeight: 1.5 }}>{p.desc}</div>
                            </div>
                        </div>
                        <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid var(--sa-border)", display: "flex", justifyContent: "flex-end" }}>
                            <button style={{ background: "transparent", color: "var(--sa-dim)", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", textTransform: "uppercase" }}>View Documentation ›</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SASecurity;
